import { LayoutPanel } from './../../../../../shared/sdk/models/LayoutPanel';
import { OnChange } from 'ngx-bootstrap';
import { SelectItem, ConfirmationService } from 'primeng/primeng';
import { PlayerGroup } from './../../../../../shared/sdk/models/PlayerGroup';
import { TransitionList } from './transitionList.class';
import { ScheduleTimeframeApi } from './../../../../../shared/sdk/services/custom/ScheduleTimeframe';
import { ScheduleTimeframe } from './../../../../../shared/sdk/models/ScheduleTimeframe';
import { RotationItemApi } from './../../../../../shared/sdk/services/custom/RotationItem';
import { ScreenCategoryApi } from './../../../../../shared/sdk/services/custom/ScreenCategory';
import { PlayerGroupApi } from './../../../../../shared/sdk/services/custom/PlayerGroup';
import { ServicesApi } from './../../../../../shared/sdk/services/custom/Services';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { GlobalPropertiesService } from './../../../../../core.module/services/global-properties.service';
import { DataService } from './../../../../../core.module/services/data.service';
import { LoopBackConfig } from './../../../../../shared/sdk/lb.config';
import { ScreenCategory } from './../../../../../shared/sdk/models/ScreenCategory';
import { CategoryRotation } from './../../../../../shared/sdk/models/CategoryRotation';
import { RotationItem, ScreenApi } from '../../../../../shared/sdk/index';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { isNumber } from 'lodash';
import { Screen } from '../../../../../shared/sdk';
import * as _ from 'lodash';
import { DataURLS } from '../../../../../shared/base.url';

@Component({
  selector: 'app-rotationitem-listitem',
  templateUrl: './rotationitem-listitem.component.html',
  styleUrls: ['./rotationitem-listitem.component.css']
})
export class RotationitemListitemComponent implements OnInit, OnChanges {
  @ViewChild('inplaceScreensPerPlay') inplaceScreensPerPlay;
  @ViewChild('inplaceDwellTime') inplaceDwellTime;
  @ViewChild('inplaceTransition') inplaceTransition;
  @ViewChild('inplacePlayerGroup') inplacePlayerGroup;

  @Input() rotationItem: RotationItem;
  @Input() screenCategory: ScreenCategory; // used when this rotation item is a screen that is part of a parent category
  @Input() layoutPanel: LayoutPanel;
  @Input() playerGroups: PlayerGroup[] = [];  // used when item is screen
  @Input() showDeleteCategoryButton: boolean; // used for default category
  @Input() categoryRotation: CategoryRotation; // used when a reference to the parent category rotatoin is needed, like in invokeTrigger()
  @Input() get checkSave(): boolean {
    return false;
  }
  set checkSave(val) {

    if (this.inplacePlayerGroup && this.inplacePlayerGroup.active) {
      this.inplacePlayerGroup.active = false; // this will trigger the "Deactivate Event" Which will force a save
      this.savePlayerGroupList(this.rotationItem);
    }
  }

  @Output() categoryNameUpdated = new EventEmitter<ScreenCategory>();
  @Output() categoryContentsChanged = new EventEmitter<ScreenCategory>(); // when soemthing changes that requires a refresh of the catetories
  @Output() itemChanged = new EventEmitter<RotationItem>(); // when something changes on a rotation item
  @Output() deleteCategoryClick = new EventEmitter(); // when the trashcan icon is clicked (used in conjunction with showDeleteCategoryButton)
  @Output() editCategory = new EventEmitter<{ screenCategory: ScreenCategory, layoutPanel: LayoutPanel, categoryRotation: CategoryRotation }>();
  @Output() displayTriggerCode = new EventEmitter<RotationItem>();
  @Output() openConditionEditor = new EventEmitter<RotationItem>();

  // add screen dialog
  public showAddScreenDialog: boolean;



  // timeframe dialog vars
  public showTimeframeDialog: boolean;
  public currentTimeframe: ScheduleTimeframe;

  // list of animateCSS transitions
  public transitionList = new TransitionList();

  // player group selection list
  public playerGroupList: SelectItem[] = [];

  // transition preview
  public showTransitionPreview = true;
  public previewTransition = '';

  public isLoading = false;


  constructor(
    public globalProps: GlobalPropertiesService,
    public logger: LoggerService,
    public servicesApi: ServicesApi,
    public playerGroupApi: PlayerGroupApi,
    public screenCategoryApi: ScreenCategoryApi,
    public screenApi: ScreenApi,
    public scheduleTimeframeApi: ScheduleTimeframeApi,
    public rotationItemApi: RotationItemApi,
    public dataService: DataService,
    public confirmationService: ConfirmationService,
  ) {
    // logger.info(`${DataURLS.BASE_URL}/${DataURLS.API_VERSION}`);
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.playerGroups) {
      this.playerGroupList = [];

      for (const pg of this.playerGroups) {
        this.playerGroupList.push({ label: pg.name, value: pg });
      }
    }

  }

  async showTriggerCode(rotationItem) {
    this.displayTriggerCode.emit(rotationItem);
  }


  // rotation item actions
  async toggleRotationItemEnable(rotationItem: RotationItem, categoryRotation: CategoryRotation) {
    this.isLoading = true;
    try {
      if (!rotationItem) {
        return;
      }
      rotationItem.enabled = !rotationItem.enabled;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error toggling rotationitem enable', error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateDwellTime($event, rotationItem: RotationItem, num) {
    this.isLoading = true;
    try {
      if (!num && !isNumber(num)) {
        return;
      }
      // update the date so a change is fired on the category rotation realtime
      // name is already bound by ngModel in html
      rotationItem.dwellTime = num;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();
      this.inplaceDwellTime.active = false; // close editor after update
      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error updating rotationitem dwell time', error);
    } finally {
      this.isLoading = false;
    }

  }

  async keydownUpdateDwellTime(event, rotationItem: RotationItem, num) {
    if (event.keyCode === 13 && num) {
      await this.updateDwellTime(event, rotationItem, num);
    }
  }

  async transitionChange(name, rotationItem: RotationItem) {
    this.isLoading = true;
    try {
      // update the date so a change is fired on the category rotation realtime
      // name is already bound by ngModel in html

      await this.rotationItemApi.patchAttributes(rotationItem.id, { transition: name }).toPromise();
      this.inplaceDwellTime.active = false; // close editor after update

      this.previewTransition = name; // set preveiw transition

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error updating rotationitem dwell time', error);
    } finally {
      this.isLoading = false;
    }

  }

  async updateScreensPerPlay($event, rotationItem: RotationItem, num) {
    this.isLoading = true;
    try {
      if (!num && !isNumber(num)) {
        return;
      }
      // update the date so a change is fired on the category rotation realtime
      // name is already bound by ngModel in html
      rotationItem.screensPerPlay = num;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();
      this.inplaceScreensPerPlay.active = false; // close editor after update

      // send change signal
      this.emitChange();
    } catch (error) {
      this.logger.error('Error updating rotationitem screens per play', error);
    } finally {
      this.isLoading = false;
    }

  }

  async keydownUpdateScreensPerPlay(event, rotationItem: RotationItem, num) {
    if (event.keyCode === 13 && num) {
      await this.updateScreensPerPlay(event, rotationItem, num);
    }
  }

  async toggleRotationItemShuffle(rotationItem) {
    this.isLoading = true;
    try {
      if (!rotationItem) {
        return;
      }
      rotationItem.random = !rotationItem.random;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error toggling screenCategroy shuffle', error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateScreenCategoryName(event, screenCategory: ScreenCategory, newName) {
    try {
      if (!newName) {
        return;
      }
      this.isLoading = true;
      // update the date so a change is fired on the category rotation realtime
      // name is already bound by ngModel in html
      screenCategory.updatedAt = new Date();
      screenCategory.name = newName;
      await this.screenCategoryApi.updateAttributes(screenCategory.id, screenCategory).toPromise();

      // notify listners that this screen category name has changed
      this.categoryNameUpdated.emit(screenCategory);

      this.emitChange();

      // send change signal
      this.emitChange();
    } catch (error) {
      this.logger.error('Error updating screenCategroy name', error);
    } finally {
      this.isLoading = false;
    }

  }

  async keydownUpdateScreenCategoryName(event, screenCategory: ScreenCategory, newName) {
    if (event.keyCode === 13 && newName) {
      await this.updateScreenCategoryName(event, screenCategory, newName);
    }
  }

  async removeRotationItemFromRotation(rotationItem: RotationItem, layoutPanel: LayoutPanel) {
    // rotation item is a belongs to relation.  So we just have to delete the rotation item, nothing else to do
    this.isLoading = true;
    try {
      const ri = new RotationItem();
      // remove from last list unless it's the default list
      await this.rotationItemApi.deleteById(rotationItem.id).toPromise();

      // update local categoryRotation to reflect deleted item
      if (!this.rotationItem.ownerScreenCategoryId) {
        const index = layoutPanel.rotationItems.findIndex(item => { return item.id === rotationItem.id; });
        if (index !== -1) { layoutPanel.rotationItems.splice(index, 1); } // remove rotationitem from array
      }


      // update screencategory to reflect deleted item
      if (this.rotationItem.ownerScreenCategoryId && this.screenCategory) {
        const index = this.screenCategory.childRotationItems.findIndex(item => { return item.id === rotationItem.id; });
        if (index !== -1) { this.screenCategory.childRotationItems.splice(index, 1); } // remove rotationitem from array
      }

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error unlinking screen categlry from rotation', error);
    } finally {
      this.isLoading = false;
    }

  }

  async updateRotationItemDate(rotationItem: RotationItem) {
    this.isLoading = true;
    try {
      if (rotationItem) {
        await this.rotationItemApi.patchAttributes(rotationItem.id, { updatedAt: new Date() }).toPromise();
      }
    } catch (error) {
      this.logger.error(`Error updating date on rotationItem`, error);
    } finally {
      this.isLoading = false;
    }

  }


  // add screen to category dialog
  openAddScreenDialogForCategory(screenCategory: ScreenCategory) {
    this.showAddScreenDialog = true;
  }


  // screen order dialog
  openScreenOrderDialog(screenCategory: ScreenCategory, categoryRotation: CategoryRotation) {

    // notify that we want to update this category
    this.editCategory.emit({ screenCategory: screenCategory, layoutPanel: this.layoutPanel, categoryRotation: categoryRotation });
  }


  async addScreens(screens: Screen[]) {
    this.isLoading = true;

    try {
      let index = this.rotationItem.screenCategory.childRotationItems.length;
      for (const scr of screens) {
        const ri = new RotationItem(); // create a new rotation item
        ri.screenId = scr.id;
        ri.ownerScreenCategoryId = this.rotationItem.screenCategory.id; // assign to current screen category
        ri.positionIndex = index;

        const newRi = <any>await this.rotationItemApi.upsert(ri).toPromise();
        const newRiWithIncludes = await this.getRotationItemById(newRi.id);

        this.rotationItem.screenCategory.childRotationItems.push(newRiWithIncludes);

        index += 1;
      }
    } catch (error) {
      this.logger.error('Error adding screen to category rotation', error);
    } finally {
      this.isLoading = false;
    }

    // notifiy listners that the category contents has changed
    // fired from here and from screenorder dialog change
    this.onCategoryContentsChanged(this.rotationItem.screenCategory);

  }

  async getRotationItemById(id: string): Promise<RotationItem> {


    const newRiWithIncludes = <RotationItem>await this.rotationItemApi.findById(id, {
      include: [{
        'screenCategory': [
          { 'childRotationItems': [{ 'screen': 'playerGroups' }, 'scheduleTimeframes'] }
        ]
      }, { 'screen': 'playerGroups' }, 'scheduleTimeframes']
    }).toPromise();

    // make sure the arrays are initilized
    if (newRiWithIncludes && !newRiWithIncludes.scheduleTimeframes) { newRiWithIncludes.scheduleTimeframes = []; }
    if (newRiWithIncludes && newRiWithIncludes.screenCategory && !newRiWithIncludes.screenCategory.childRotationItems) { newRiWithIncludes.screenCategory.childRotationItems = []; }
    if (newRiWithIncludes && newRiWithIncludes.screen && !newRiWithIncludes.screen.playerGroups) { newRiWithIncludes.screen.playerGroups = []; }

    return newRiWithIncludes;
  }



  // timeframe editor dialog
  openTimeframeDialog(timeframe: ScheduleTimeframe, rotationItem: RotationItem) {

    if (timeframe) {
      this.currentTimeframe = _.cloneDeep(timeframe);

    } else {
      // create new timeframe with defaults
      this.currentTimeframe = null;
    }

    // display the dialog
    this.showTimeframeDialog = true;
  }

  async saveTimeframe(timeframe) {
    try {

      this.isLoading = true;
      // set timeframe parent
      timeframe.rotationItemId = this.rotationItem.id;

      // save timeframe
      const newTimeframe = <ScheduleTimeframe>await this.scheduleTimeframeApi.upsert(timeframe).toPromise();

      // show local copy on rotation item (add if not there)
      const existingIndex = this.rotationItem.scheduleTimeframes.findIndex(item => { return item.id === newTimeframe.id; });
      if (existingIndex !== -1) {
        this.rotationItem.scheduleTimeframes.splice(existingIndex, 1); // remove existing item
        this.rotationItem.scheduleTimeframes.splice(existingIndex, 0, newTimeframe); // add back item
      } else {
        this.rotationItem.scheduleTimeframes.push(newTimeframe); // add to end of array
      }

      this.currentTimeframe = null;

      // update the target's date so a change is fired for realtime
      this.showTimeframeDialog = false; // close editor after update

      // send change signal on exit
      this.emitChange();

    } catch (error) {
      this.logger.error('Error saving schedule timeframe', error);
    } finally {
      this.isLoading = false;
    }

  }

  async removeTimeframe(timeframe: ScheduleTimeframe, rotationItem: RotationItem) {
    event.stopPropagation();  // will stop the click from passing to the timeframe div so the editor isn't opened

    try {
      this.isLoading = true;
      // delete timeframe
      await this.scheduleTimeframeApi.deleteById(timeframe.id).toPromise();

      let index;

      if (rotationItem) {
        index = rotationItem.scheduleTimeframes.findIndex(item => { return item.rotationItemId === rotationItem.id; });
        if (index !== -1) { rotationItem.scheduleTimeframes.splice(index, 1); } // remove item from list
      }

      // update time of categoryrotation or rotationitem
      await this.updateRotationItemDate(this.rotationItem);

      // send change signal on exit
      this.emitChange();

    } catch (error) {
      this.logger.error('Error deleting scheduletimeframe ', error);
    } finally {
      this.isLoading = false;
    }



  }





  async savePlayerGroupList(rotationItem: RotationItem) {
    try {
      // link selected playergroups to screen
      for (const pg of this.playerGroupList) {
        const result = rotationItem.screen.playerGroups.find(item => { return item.id === pg.value.id; });

        if (result) {
          await this.screenApi.linkPlayerGroups(rotationItem.screen.id, pg.value.id).toPromise();
        } else {
          await this.screenApi.unlinkPlayerGroups(rotationItem.screen.id, pg.value.id).toPromise();
        }
      }

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();
      // send change signal on exit
      this.emitChange();

    } catch (error) {
      this.logger.error('could not save playergroup selection to screen', error);
    }
  }

  emitChange() {
    // notify listeners that a property has changed like transition, dwell time, enabled.. etc..
    this.itemChanged.emit(this.rotationItem);
  }

  async onCategoryContentsChanged(screenCategory: ScreenCategory) {
    // fires when screenorder dialog modifies the contents of a category (like position changes in a list)
    this.categoryContentsChanged.emit(this.rotationItem.screenCategory);
  }


  deleteCategory() {
    this.deleteCategoryClick.emit();
    this.deleteCategoryConfirm(this.rotationItem.screenCategory);
  }

  async deleteCategoryConfirm(screenCategory: ScreenCategory) {
    // don't allow deleting the last rotation

    this.confirmationService.confirm({
      header: `Delete Category '${screenCategory.name}'?`,
      key: 'deleteRotation',
      icon: 'fa fa-trash',
      message: `Are you sure you want to delete the category '<strong>${screenCategory.name}</strong>'?
                          <p>This will remove this category from all rotations and all players.</p>
                          <p><strong>This action cannot be undone</strong></p>`,
      accept: async () => {

        await this.deleteScreenCategory(screenCategory);


      }
    });


  }

  async deleteScreenCategory(sc) {
    // show confirm dialog?
    try {
      const result = await this.screenCategoryApi.deleteById(sc.id).toPromise();

      this.onCategoryContentsChanged(this.rotationItem.screenCategory); // tell listners we need a refresh

    } catch (error) {
      this.logger.error(`Error deleting screen category: `, error);
    }
  }


  // triggering controls

  async toggleTrigger(rotationItem: RotationItem) {
    try {
      if (!rotationItem) {
        return;
      }

      this.isLoading = true;
      rotationItem.triggerable = !rotationItem.triggerable;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error toggling trigger enable', error);
    } finally {
      this.isLoading = false;
    }
  }

  async invokeTrigger(rotationItem: RotationItem) {
    // send trigger command to server for this screen
    // need RotationItemId and categoryRotationId
    this.logger.info(`Triggering rotation item '${rotationItem.id}'`);

    try {
      if (!rotationItem) {
        return;
      }
      const categoryRotationId = this.categoryRotation.id;

      await this.rotationItemApi.triggerScreen(rotationItem.id, categoryRotationId).toPromise();

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Rotation item could not be triggered', error);
    }
  }

  async toggleinScheduleWhenTriggerEnabled(rotationItem: RotationItem) {
    try {
      if (!rotationItem) {
        return;
      }
      rotationItem.inScheduleWhenTriggerEnabled = !rotationItem.inScheduleWhenTriggerEnabled;

      await this.rotationItemApi.updateAttributes(rotationItem.id, rotationItem).toPromise();

      // send change signal
      this.emitChange();

    } catch (error) {
      this.logger.error('Error toggling trigger enable', error);
    }
  }

  async editAdvancedConditions(rotationItem: RotationItem) {
    // show advanced conditions dialog
    this.openConditionEditor.emit(rotationItem);

  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/rotationitem-listitem/rotationitem-listitem.component.ts